import { Link } from "react-router-dom";
import { Logo } from "@/components/brand/Logo";
import { useI18n } from "@/i18n/I18nProvider";

export default function NotFound() {
  const { t } = useI18n();
  return (
    <div className="flex min-h-[100dvh] flex-col items-center justify-center gap-6 bg-[#F8FAFC] px-6 text-center">
      <Logo size="md" testId="notfound-logo" />
      <h1 data-testid="notfound-title" className="font-display text-2xl font-extrabold text-[#000B45]">{t("notFound.title")}</h1>
      <Link to="/" data-testid="notfound-back" className="rounded-lg bg-[#000B45] px-5 py-3 text-sm font-bold text-white hover:bg-[#000624]">
        {t("notFound.back")}
      </Link>
    </div>
  );
}
